<template>
    <div class="container">
        <slot />
    </div>
</template>

<style lang="scss" scoped>
@use '@design' as *;

.container {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100vh;
    padding: 0 $s-l;
    overflow-x: hidden;
}
</style>
